import { Directive, HostBinding } from '@angular/core';

@Directive()
export abstract class ReportWrapperComponentBase {
   @HostBinding('class')
   elementClass = 'report-wrapper';
}
